<template>
	<div class="side-panel panel-mobile" @click="requestQuoteClickClose" :class="{'--is-visible': requestQuote}" ref="ContactForm">
		<div class="side-panel__container" :class="`--position-${position}`">
			<div class="side-panel__content">
				<div class="side-panel__header">
					<h2 v-text="$__('form.request_quote')"></h2>
					<button class="side-panel__close" @click.prevent="requestQuoteClose"><svg class="ticon"><use xlink:href="/images/icons.svg#icon-close"></use></svg></button>
				</div>

				<div class="side-panel__body">
					<div class="custom-product">
						<div class="custom-product--wrapper">
							<img :src="product_info.thumbnail">
							<div class="info">
								<span class="title" v-text="form.product_title"></span>
								<span class="category" v-text="product_info.category.title"></span>
							</div>
						</div>
					</div>
					<div class="send-quote">
						<div v-if="!submitted">
							<validationObserver ref="observer" v-slot="{ invalid }" tag="form" @submit.prevent="saveForm">

								<div class="form-row">
									<div class="col-md-6 form-group input-extra">
										<ValidationProvider
											rules="required"
											v-slot="{ errors }"
											class="input-name"
											tag="div"
										>
											<input type="text" class="form-control" id="inputname" placeholder=" " v-model="form.name" :class="{ 'input-error is-invalid': errors.length }">
											<label for="inputname" v-text="$__('checkout.form.billing_name')"></label>
											<div v-if="errors.length" class="invalid-feedback">
												{{ errors[0] }}
											</div>
										</ValidationProvider>
									</div>
									<div class="col-md-6 form-group input-extra">
										<ValidationProvider
											rules="required"
											v-slot="{ errors }"
											class="input-name"
											tag="div"
										>
											<input type="text" class="form-control" id="inputlastname" placeholder=" " v-model="form.lastname" :class="{ 'input-error is-invalid': errors.length }">
											<label for="inputlastname" v-text="$__('checkout.form.billing_surname')"></label>
											<div v-if="errors.length" class="invalid-feedback">
												{{ errors[0] }}
											</div>
										</ValidationProvider>
									</div>
								</div>

								<div class="form-row">
									<div class="col-md-6 form-group input-extra">
										<ValidationProvider
											rules="required|email"
											v-slot="{ errors, failedRules }"
											class="input-name"
											tag="div"
										>
											<input type="email" class="form-control" id="inputmail" placeholder=" " v-model="form.email" :class="{ 'input-error is-invalid': errors.length }">
											<label for="inputmail" v-text="$__('checkout.form.billing_email')"></label>
											<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.error.required_email')"></div>
											<div v-else-if="failedRules.email" class="invalid-feedback" v-text="$__('form.error.invalid_email')"></div>
										</ValidationProvider>
									</div>
									<div class="col-md-6 form-group input-extra">
										<ValidationProvider
											rules=""
											v-slot="{ errors, failedRules }"
											class="input-name"
											tag="div"
										>
											<input type="text" class="form-control" id="inputstudio" placeholder=" " v-model="form.studio" :class="{ 'input-error': errors.length }">
											<label for="inputstudio" v-text="$__('form.studio')"></label>
											<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.error.generic')"></div>
										</ValidationProvider>
									</div>
								</div>

								<div class="form-row">
									<div class="col-md-6 form-group input-extra">
										<ValidationProvider
											rules="required"
											v-slot="{ errors, failedRules }"
											class="input-name"
											tag="div"
										>
											<input type="text" class="form-control" id="inputaddress" placeholder=" " v-model="form.address" :class="{ 'input-error': errors.length }">
											<label for="inputaddress" v-text="$__('checkout.form.billing_address')"></label>
											<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.error.address_required')"></div>
										</ValidationProvider>
									</div>
									<div class="col-md-2 form-group input-extra">
										<ValidationProvider
											rules="required"
											v-slot="{ errors, failedRules }"
											class="input-name"
											tag="div"
										>
											<input type="text" class="form-control" id="inputpost" placeholder=" " v-model="form.post" :class="{ 'input-error': errors.length }">
											<label for="inputpost" v-text="$__('checkout.form.billing_post')"></label>
											<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.error.generic')"></div>
										</ValidationProvider>
									</div>
									<div class="col-md-4 form-group input-extra">
										<ValidationProvider
											rules="required"
											v-slot="{ errors, failedRules }"
											class="input-name"
											tag="div"
										>
											<input type="text" class="form-control" id="inputcity" placeholder=" " v-model="form.city" :class="{ 'input-error': errors.length }">
											<label for="inputcity" v-text="$__('checkout.form.billing_town')"></label>
											<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.error.generic')"></div>
										</ValidationProvider>
									</div>
								</div>

								<div class="form-row mb-4">
									<div class="col-md-6 form-group input-extra">
										<ValidationProvider
											rules=""
											v-slot="{ errors, failedRules }"
											class="input-name"
											tag="div"
										>
											<input type="text" class="form-control" id="inputphone" placeholder=" " v-model="form.phone" :class="{ 'input-error': errors.length }">
											<label for="inputname" v-text="$__('checkout.form.billing_phone')"></label>
											<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.error.generic')"></div>
										</ValidationProvider>
									</div>
									<div class="col-md-6 form-group input-extra">
										<ValidationProvider
											rules="is_not:choose"
											v-slot="{ errors }"
											class="input-name"
											tag="div"
										>
											<!-- <label for="inputcountry">Country</label> -->
											<select v-model="form.country" :class="{ 'input-error is-invalid': errors.length }" id="inputcountry" class="custom-select">
												<option value="choose" v-text="$__('checkout.select_country')"></option>
												<option v-for="country in countries" v-text="country.title" :value="country.title"></option>
											</select>
											<div v-if="errors.length" class="invalid-feedback">
												{{ errors[0] }}
											</div>
										</ValidationProvider>

									</div>
								</div>

								<div class="form-row mb-4">
									<div class="col-md-6 form-group input-extra">
										<ValidationProvider
											rules="required"
											v-slot="{ errors, failedRules }"
											class="input-name"
											tag="div"
										>
											<input type="number" class="form-control" id="inputqty" min="1" placeholder=" " v-model="form.qty" :class="{ 'input-error is-invalid': errors.length }">
											<label for="inputqty" v-text="$__('cart.quantity')"></label>
											<div v-if="errors.length" class="invalid-feedback">
												{{ errors[0] }}
											</div>
										</ValidationProvider>
									</div>
									<div class="col-md-6 form-group input-extra">
										<textarea id="inputcomment" v-model="form.comment" class="form-control"></textarea>
										<label for="inputcomment" v-text="$__('cart.comments')"></label>
									</div>
								</div>

								<div class="form-radios mb-2">
									<ValidationProvider
										rules=""
										v-slot="{ errors, failedRules }"
										class="form-row"
										tag="div"
									>
										<div class="col-md-6 custom-control custom-radio">
											<input type="radio" class="custom-control-input form-control" id="input4studio" name="isstudio" value="1" v-model="form.is_studio" :class="{ 'input-error': errors.length }" checked>
											<label class="custom-control-label" for="input4studio" v-text="$__('form.select.buy_for_studio')"></label>
										</div>
										<div class="col-md-6 custom-control custom-radio">
											<input type="radio" class="custom-control-input form-control" id="input4home" name="isstudio" value="0" v-model="form.is_studio" :class="{ 'input-error': errors.length }">
											<label class="custom-control-label" for="input4home" v-text="$__('form.select.buy_for_home')"></label>
										</div>
										<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.select.choose')"></div>
									</ValidationProvider>
								</div>
								<div class="form-group">
									<ValidationProvider
										rules=""
										v-slot="{ errors, failedRules }"
										class="input-name"
										tag="div"
									>
										<div class="custom-control custom-checkbox">
											<input class="custom-control-input" type="checkbox" id="inputreseller" v-model="form.is_reseller" value="1">
											<label class="custom-control-label" for="inputreseller" v-text="$__('form.reseller')"></label>
										</div>
									</ValidationProvider>
								</div>
								<div class="form-group input-extra" v-if="form.is_reseller">
									<ValidationProvider
														rules="required"
														v-slot="{ errors, failedRules }"
														class="input-name"
														tag="div"
									>
										<label for="inputresellercode" v-text="$__('form.reseller_code')"></label>
										<input type="text" class="form-control" id="inputresellercode" placeholder="Enter your promo code" v-model="form.resellercode" :class="{ 'input-error is-invalid': errors.length }">

										<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.promo_code.required')"></div>
									</ValidationProvider>
								</div>
								<button type="submit" :disabled="disabled" class="btn btn-primary btn-lg mt-4" v-text="$__('form.button.request_quote')"></button>
							</validationObserver>
						</div>
						<div v-else>
							<p v-text="$__('form.request_success')"></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate';
import { required, email, is_not } from 'vee-validate/dist/rules';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

extend('email', {
	... email, email
});

extend('required', {
	...required,
	message: 'This field is required',
});

extend('is_not', {
	...is_not,
	message: 'This field is required',
});

export default {
	name: "ContactForm",
	props: {
		product: Number,
		product_info: Object,
	},
	data() {
		return {
			form: {
				is_studio: 1,
				is_reseller: 0,
				product_id: this.product,
				product_title: this.product_info.title,
				product_note: null,
				product: null,
				name: null,
				lastname: null,
				email: null,
				country: 'choose',
				lang: window.sharedData.locale,
				qty: 1
			},
			position: {
				type: String,
				default: 'right'
			},
			submitted: false,
			disabled: false,
			requestQuote: false,
			countries: null,
			regions: null,
			fullPage: true,
			loaderOptions: {
				container: this.fullPage ? null : this.$refs.ContactForm,
				loader: 'dots',
				canCancel: false,
				color: '#E6007E',
				opacity: 0.5,
				zIndex: 999999,
			},
		}
	},
	computed: {
		...mapGetters('cart', {
			current_product: 'currentProduct',
		})
	},
	components: {
		ValidationObserver,
		ValidationProvider
	},
	methods: {
		async saveForm () {
			if (!this.form.product_note) {
				this.form.product_note = this.current_product.length !== 'choose' ? this.current_product.length : this.product.title
			}
			const isValid = await this.$refs.observer.validate();
			if (!isValid) {
				return false;
			}
			let loader = this.$loading.show(this.loaderOptions);
			axios.post('/api/form/quote', this.form)
				.then(response => {
					if (!response.error) {
						this.disabled = false;
						this.submitted = true;
						loader.hide()
					}
				})
				.catch(function (error) {
					// error
					loader.hide()
				});
			return false;
		},
		requestQuoteShow (info, variant) {
			this.form.product_title = this.product_info.title + ', ' + info;
			if (variant && (variant.locale_price || variant.title)) {
				if (variant.locale_price !== null) {
					this.form.product_title += ', ' + variant.locale_price.title
				} else {
					this.form.product_title += ', ' + variant.title
				}
			}
			this.form.product_note = this.form.product_title
			this.requestQuote = true;
			document.querySelector('html').classList.add('overlay');
		},
		requestQuoteClose () {
			this.requestQuote = false;
			this.form.product_title = this.product_info.title;
			document.querySelector('html').classList.remove('overlay');
		},
		requestQuoteClickClose (e) {
			e.stopPropagation();
			if (e.target.classList.contains('side-panel')) {
				this.requestQuoteClose();
			}
		}
	},
	mounted() {
		axios.get('/api/countries')
			.then(response => {
				if (!response.error) {
					this.countries = response.data;
				}
			})
			.catch(function (error) {
				// error
			});
	},
	created () {
		let self = this;
		window.addEventListener('keydown', function (event) {
			if (self.requestQuote && event.key === 'Escape') {
				self.requestQuoteClose();
			}
		});
	}
}
</script>
